import { useRouter } from 'next/router';

export function useLocale() {
  const locale = useRouter();
  return locale;
}

export * from './client';
export * from './server';
